import { useState, useCallback, useEffect, useRef } from "react";   
import { Row, Col, Button, Dropdown, Toast, ToastContainer } from 'react-bootstrap'; 
import { getSettings, clearSettings } from "../../apis/settingApi";
import { SaveTableSettingsModal } from "./SaveTableSettingsModal";

export const SaveTableSettings = ({ gridParams, gridRef, tableType}) => {
    
    const [showSaveSettingsModal, setShowSaveSettingsModal] = useState(false);
    const [savedSettings, setSavedSettings] = useState(null);
    const [toast, setToast] = useState({ show: false, message: '' });
    const hasAppliedOnMount = useRef(false);

    const applySort = useCallback((sortModel) => {
        if(sortModel && sortModel.length > 0)
        {
            
            gridRef.current.api.applyColumnState({defaultState: { sort: null },});
            gridRef.current.api.applyColumnState({state: sortModel, applyOrder: false});
        }
    }, []);

    useEffect(() => {
        if (hasAppliedOnMount.current) return;
        if (!gridParams?.api || !gridRef?.current?.api) return;

        hasAppliedOnMount.current = true;

        const loadAndApply = async () => {
            try {
                const response = await getSettings();
                const settings = response;

                if (settings && settings[tableType]) {
                    const savedFilters = settings[tableType].filters;
                    const savedSort = settings[tableType].sort;

                    setSavedSettings({filter: savedFilters, sort: savedSort});

                    if (savedSort && savedSort.length > 0) {
                        gridRef.current.api.applyColumnState({defaultState: { sort: null }});
                        gridRef.current.api.applyColumnState({state: savedSort, applyOrder: false});
                    }

                    if (savedFilters && Object.keys(savedFilters).length > 0) {
                        gridRef.current.api.setFilterModel(savedFilters);
                    }
                }
            } catch (error) {
                // Silently ignore - no saved settings to apply
            }
        };

        loadAndApply();
    }, [gridParams, tableType, gridRef]);
    
    const applySettings = () => {
        if(!savedSettings || (savedSettings.filter === null && savedSettings.sort === null))
        {
            setToast({ show: true, message: 'No saved settings to apply. Use "Save Filters" first.' });
            return;
        }
        if(savedSettings.sort !== null)
        {
          if(savedSettings.sort.length > 0)
          {
            applySort(savedSettings.sort);
          }
        }
        if(savedSettings.filter !== null)
        {
          gridRef.current.api.setFilterModel(savedSettings.filter);
        }
    }
    

    const handleGetFilters = async () => {
        const response = await getSettings();
        const settings = response;
        
        if(settings && settings[tableType])
        {
            setSavedSettings({filter: settings[tableType].filters, sort: settings[tableType].sort});
        }
    }

    const handleClearSettings = async () => {
        if(!savedSettings || (savedSettings.filter === null && savedSettings.sort === null))
        {
            setToast({ show: true, message: 'No saved settings to clear. Use "Save Filters" first.' });
            return;
        }
        await clearSettings(tableType);
        
        setSavedSettings(null);
        
        gridRef.current.api.setFilterModel(null);
        gridRef.current.api.applyColumnState({defaultState: { sort: null }});
    }
    
    const handleOpenSaveJobModal = async () => {
        setShowSaveSettingsModal(true);
    }
    return (
        <>
            <SaveTableSettingsModal show={showSaveSettingsModal} setShow={setShowSaveSettingsModal} gridParams={gridParams} tableType={tableType}/>
            <Dropdown className="d-inline mx-2" onToggle={(isOpen) => { if (isOpen) handleGetFilters(); }}>
                <Button className={"button-table outside-table-button"} onClick={handleOpenSaveJobModal} label="Save Filters" aria-label="Save Filters">
                    Save Filters
                </Button>
                <Dropdown.Toggle className="button-table button-icon"  split id="dropdown-basic"/>
                <Dropdown.Menu className="save-filters-dropdown-menu">
                    <Dropdown.Item onClick={applySettings} className="apply-saved-settings">Apply Saved Settings</Dropdown.Item>
                    <Dropdown.Item onClick={handleClearSettings} className="clear-saved-settings">Clear Saved Settings</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
            
            <ToastContainer className="p-3 position-fixed bottom-0 end-0">
                <Toast show={toast.show} bg="warning" onClose={() => setToast({ ...toast, show: false })} delay={4000} autohide>
                    <Toast.Header>
                        <strong className="me-auto">Save Filters</strong>
                    </Toast.Header>
                    <Toast.Body>{toast.message}</Toast.Body>
                </Toast>
            </ToastContainer>
        </>
    );
}